import { put, select, takeEvery, all, call } from "redux-saga/effects";
import {
  GET_MDR_DASHBOARD_ALL,
  SET_MDR_DASHBOARD_INCIDENT_LIST,
  SET_MDR_DASHBOARD_INCIDENT_SUMMARY,
  SET_MDR_DASHBOARD_OVERVIEW_COUNT,
  MDR_DASHBOARD_LOADER,
  getDashboardOverviewCount,
  getIncidentList,
  getIncidentSummary,
  FETCH_CUBE_INCIDENT_TABLE,
  SET_INCIDENT_TABLE_LOADER,
  SET_INCIDENT_TABLE_DATA,
  SET_TABLE_DATA_JIRA,
  fetchTableDataJira,
  GET_TABLE_DATA_JIRA,
  SET_JIRA_INCIDENT_TABLE_LOADER
} from "../mdrConstants";
import { getAxiosHeaders, getService } from "../../../library/RestAPI";
import { getCubejsApi, redirectToLogin } from "../../../components/common/Dashboard/cubejs-util";


function* fetchCubeIncidentTable(action) {
  const { offset, limit } = action.payload;
  // Get epoch timestamps directly from state
  const fromDateEpoch = yield select((state) => state.mdrReducer.fromTimeStamp);
  const toDateEpoch = yield select((state) => state.mdrReducer.toTimeStamp);
  let cubejsApi = getCubejsApi();

  // Build query with epoch values
  const tableQuery = [
    {
      type: "incidentTable",
      queryCall: "IncidentsTable",
      query: [
        {
          dimensions: [
            "IncidentsTable.priority",
            "IncidentsTable.resolved",
            "IncidentsTable.status",
            "IncidentsTable.incidentTime",
            "IncidentsTable.incidentId",
            "IncidentsTable.name",
            "IncidentsTable.priorityNum",
            "IncidentsTable.city",
            "IncidentsTable.stateDetails",
            "IncidentsTable.assignee",
            "IncidentsTable.jiraTicketId"
          ],
          order: [["IncidentsTable.incidentTime", "desc"]],
          timeDimensions: [],
          limit: limit,
          offset: offset,
          filters: [
            {
              member: "IncidentsTable.incidentTime",
              operator: "gte",
              values: [String(fromDateEpoch)] // pass as epoch
            },
            {
              member: "IncidentsTable.incidentTime",
              operator: "lte",
              values: [String(toDateEpoch)] // pass as epoch
            }
          ]
        },
        {
          measures: ["IncidentsTable.count"],
          filters: [
            {
              member: "IncidentsTable.incidentTime",
              operator: "gte",
              values: [String(fromDateEpoch)]
            },
            {
              member: "IncidentsTable.incidentTime",
              operator: "lte",
              values: [String(toDateEpoch)]
            }
          ]
        }
      ]
    }
  ];

  try {
    yield put({ type: SET_INCIDENT_TABLE_LOADER, payload: true });

    // Query for count
    const countResultSet = yield call(
      [cubejsApi, cubejsApi.load],
      tableQuery[0].query[1]
    );
    const countData = countResultSet.rawData();

    // Query for table data
    const tableResultSet = yield call(
      [cubejsApi, cubejsApi.load],
      tableQuery[0].query[0]
    );
    const tableData = tableResultSet.rawData();


    // Example dispatch (if needed)
    yield put({
      type: SET_INCIDENT_TABLE_DATA,
      payload: {
        data: tableData,
        totalCount: countData[0][`${tableQuery[0].queryCall}.count`]
      }
    });
  } catch (error) {
    console.error(error);
    redirectToLogin(error);
  } finally {
    yield put({ type: SET_INCIDENT_TABLE_LOADER, payload: false });
  }
}

function* fetchIncidentSummary(fromDate, toDate) {
  const options = {
    method: "GET",
    url: getIncidentSummary(fromDate, toDate),
    headers: getAxiosHeaders(true),
  };
  const res = yield call(getService, options);
  if (res?.status === 200) {
    yield put({ type: SET_MDR_DASHBOARD_OVERVIEW_COUNT, payload: res.data?.counts });
    yield put({ type: SET_MDR_DASHBOARD_INCIDENT_LIST, payload: res.data?.types });
    yield put({ type: SET_MDR_DASHBOARD_INCIDENT_SUMMARY, payload: res.data?.summary });
  }
}

 const formatDate = (epoch) => {
   const d = new Date(epoch);
   const year = d.getFullYear();
   const month = String(d.getMonth() + 1).padStart(2, "0");
   const day = String(d.getDate()).padStart(2, "0");
   return `${year}-${month}-${day}`;
 };

function* fetchAllDashboardData() {
  yield put({ type: MDR_DASHBOARD_LOADER, payload: true });

  const fromDateEpoch = yield select(state => state.mdrReducer.fromTimeStamp);
  const toDateEpoch = yield select(state => state.mdrReducer.toTimeStamp);

  const fromDate = formatDate(fromDateEpoch);
  const toDate = formatDate(toDateEpoch);

  try {
    yield call(fetchIncidentSummary, fromDate, toDate);
  } catch (err) {
    console.error(err);
    redirectToLogin(err);
  } finally {
    yield put({ type: MDR_DASHBOARD_LOADER, payload: false });
  }
}
function* fetchJiraTable(action) {
  yield put({ type: SET_JIRA_INCIDENT_TABLE_LOADER, payload: true });
  const { reset, size, hasNext, hasPrevious, priorityFilters, categoryFilters } = action.payload;

  const fromDateEpoch = yield select((state) => state.mdrReducer.fromTimeStamp);
  const toDateEpoch = yield select((state) => state.mdrReducer.toTimeStamp);

  const fromDate = formatDate(fromDateEpoch);
  const toDate = formatDate(toDateEpoch);

  let queryParam = "";
  if (reset) {
    queryParam = `reset=true`;
  } else if (hasNext) {
    queryParam = `hasNext=true`;
  } else if (hasPrevious) {
    queryParam = `hasPrevious=true`;
  }

  let paramData = {};
  let priorityFilter = "";
  let categoryFilter = "";

  if (priorityFilters && priorityFilters.length > 0) {
    priorityFilter = priorityFilters.join(",");
    paramData["priority"] = priorityFilter;
  }
  if (categoryFilters && categoryFilters.length > 0) {
    categoryFilter = categoryFilters.join(",");
    paramData["status"] = categoryFilter;
  }

  const options = {
    method: "GET",
    url: fetchTableDataJira(fromDate, toDate, size, queryParam),
    params: paramData,
    headers: getAxiosHeaders(true),
  };

  try {
    const response = yield call(getService, options);
    if (response?.status === 200) {
      yield put({ type: SET_TABLE_DATA_JIRA, payload: response.data });
      yield put({ type: SET_JIRA_INCIDENT_TABLE_LOADER, payload: false });
    } else {
      yield put({ type: SET_JIRA_INCIDENT_TABLE_LOADER, payload: false });
    }
  } catch (error) {
    console.error(error);
    redirectToLogin(error);
    yield put({ type: SET_JIRA_INCIDENT_TABLE_LOADER, payload: false });
  }
}


function* MDRDashboardSaga() {
  yield takeEvery(GET_MDR_DASHBOARD_ALL, fetchAllDashboardData);
  yield takeEvery(FETCH_CUBE_INCIDENT_TABLE, fetchCubeIncidentTable);
  yield takeEvery(GET_TABLE_DATA_JIRA, fetchJiraTable);
}

export default MDRDashboardSaga;
